if (!customElements.get('product-collections-widget')) {
  class ProductCollectionsWidget extends HTMLElement {
    connectedCallback() {
      this.isDesignMode = typeof Shopify !== 'undefined' && Shopify.designMode;
      this.sectionId = this.dataset.sectionId;
      this.maxVisible = Number.parseInt(this.dataset.maxVisible, 10) || 5;
      this.randomize = this.dataset.randomize === 'true';
      this.items = Array.from(this.querySelectorAll('.product-collections-widget__item'));

      if (!this.items.length || !this.randomize) return;

      this.renderVisibleItems();

      if (this.isDesignMode) {
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        document.addEventListener('shopify:block:deselect', this.handleBlockDeselect);
        document.addEventListener('shopify:section:load', this.handleSectionLoad);
      }
    }

    disconnectedCallback() {
      if (!this.isDesignMode || !this.randomize) return;

      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
      document.removeEventListener('shopify:section:load', this.handleSectionLoad);
    }

    handleSectionLoad = (event) => {
      if (event.detail.sectionId !== this.sectionId) return;

      this.items = Array.from(this.querySelectorAll('.product-collections-widget__item'));
      this.renderVisibleItems();
    };

    handleBlockSelect = (event) => {
      if (event.detail.sectionId !== this.sectionId) return;

      const selectedItem = this.querySelector(`[data-block-id="${event.detail.blockId}"]`);
      if (!selectedItem) return;

      this.items.forEach((item) => {
        item.classList.add('is-hidden');
      });

      selectedItem.classList.remove('is-hidden');
      selectedItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    };

    handleBlockDeselect = (event) => {
      if (event.detail.sectionId !== this.sectionId) return;
      this.renderVisibleItems();
    };

    renderVisibleItems() {
      const maxItems = Math.min(this.maxVisible, this.items.length);
      const visibleItems = this.shuffle([...this.items]).slice(0, maxItems);

      this.items.forEach((item) => {
        item.classList.add('is-hidden');
      });

      visibleItems.forEach((item, index) => {
        item.classList.remove('is-hidden');
        item.style.order = String(index);
      });
    }

    shuffle(items) {
      for (let index = items.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        [items[index], items[randomIndex]] = [items[randomIndex], items[index]];
      }

      return items;
    }
  }

  customElements.define('product-collections-widget', ProductCollectionsWidget);
}
